(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.onScrollHandler = null;
    this.hideHeaderOnScrollUp = null;
    this.mediaQueryList = null;
    this.handleMediaChange = null;
    this.observer = null;
    this.isScrolling = null;
    this.disclosures = null;
    this.searchModal = null;
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};

    this.setHeaderHeight();

    this.mediaQueryList = window.matchMedia('(max-width: 990px)');
    this.handleMediaChange = this.setHeaderHeight.bind(this);

    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.handleMediaChange);
    } else if (this.mediaQueryList.addListener) {
      this.mediaQueryList.addListener(this.handleMediaChange);
    }

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    this.createObserver();
  }

  setHeaderHeight() {
    if (!this.header) return;
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    if (this.hideHeaderOnScrollUp) {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }

    if (this.onScrollHandler) {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    if (this.mediaQueryList && this.handleMediaChange) {
      if (this.mediaQueryList.removeEventListener) {
        this.mediaQueryList.removeEventListener('change', this.handleMediaChange);
      } else if (this.mediaQueryList.removeListener) {
        this.mediaQueryList.removeListener(this.handleMediaChange);
      }
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.isScrolling) {
      window.clearTimeout(this.isScrolling);
      this.isScrolling = null;
    }
  }

  createObserver() {
    if (!this.header) return;

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver((entries) => {
      if (!entries || !entries.length) return;
      this.headerBounds = entries[0].intersectionRect;
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    });

    this.observer.observe(this.header);
  }

  onScroll() {
    if (!this.header) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(() => this.hide());
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(() => this.reveal());
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = window.setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(() => this.hide());
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(() => this.reset());
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.header || this.headerIsAlwaysSticky) return;

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (!this.header || this.headerIsAlwaysSticky) return;

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (!this.header || this.headerIsAlwaysSticky) return;

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    if (!this.header) return;

    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

    this.disclosures.forEach((disclosure) => {
      if (disclosure && typeof disclosure.close === 'function') {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    if (!this.header) return;

    this.searchModal = this.searchModal || this.header.querySelector('details-modal');

    if (!this.searchModal) return;

    if (typeof this.searchModal.close === 'function') {
      this.searchModal.close(false);
      return;
    }

    if (typeof this.searchModal.removeAttribute === 'function') {
      this.searchModal.removeAttribute('open');
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
